import React, { useEffect, useRef } from "react";
import arrowLeft from "../../../../assets/grayArrowLeft.svg";
import "./Career.scss";
import classNames from "classnames";
import useWindowWidth from "../../../../hooks/useWindowWidth";
import useCareer from "../../../../hooks/useCareer";
import { AffiliateCodeModal, BookModal, CancelModal, ChoosePlanFirstModal } from "../../../../modals";
import MoreRecommendations from "../../../../modals/MoreRecommendations";
import { useState } from "react";
import VideoPlayer from "../../../../components/VideoPlayer";
import Chatbot from "../../../../components/Chatbot";
import { formatText, isAccessFeature, isHTML } from "../../../../common/utils";
import { useDispatch, useSelector } from "react-redux";
import { initCompanions } from "../../../../redux/actions";
import { useNavigate, useOutletContext } from "react-router-dom";
import useAffiliateCodeModal from "../../../../hooks/useAffiliateCodeModal";
import { authUser } from "../../../../redux/selectors/authSelectors";
const Career = () => {
  const descriptionRef = useRef(null);
  const [isDefaultHeight, setIsDefaultHeight] = useState(true);
  const [isMoreRecommendations, setIsMoreRecommendations] = useState(false);
  const [allowCareerBuddy, setAllowCareerBuddy] = useState(false);
  const { user } = useOutletContext();
    const {role} = useSelector(authUser);
  const isErrorPricing = isAccessFeature({...user,role});
  const navigate = useNavigate();
  const { isMobile } = useWindowWidth();
  const {
    navigateBack,
    state,
    profile,
    isConfirmModal,
    modalInfo,
    isSavedCareer,
    handleBack,
    handlescore,
    handleClose,
    handleBookValidation,
    handleConfirm,
    handleSaveCareer,
    showLoader,
  } = useCareer();
const {
    affiliateCodeModal,
    choosePlanFirstOpen,
    closeAffiliateCodeModal,
    closeChoosePlanFirstModal,
    confirmChoosePlanFirstModal,
    openAffiliateCodeModal,
    setAffiliateCode,
    submitAffiliateCode,
  } = useAffiliateCodeModal(user);
  const dispatch = useDispatch();
  const { interestedCareerSaved } = useSelector(
    (state) => state.scenariosReducer
  );
  const { aiAgents } = useSelector((state) => state.aiCompanionsReducer);

  useEffect(() => {
    if (aiAgents && aiAgents?.results && aiAgents?.results.length > 0) {
      setAllowCareerBuddy(true);
    }
  }, [aiAgents]);

  useEffect(() => {
    dispatch(initCompanions({ name__iexact: "Career Buddy" }));
    const div = document.querySelector(".profileCont");
    if (div) {
      div.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  }, []);

  useEffect(() => {
    const descriptionHeight = descriptionRef.current?.offsetHeight || 0;
    setIsDefaultHeight(descriptionHeight > 426);
  }, [state?.description_long]);

  const handleRecommend = (val = null) => {
    setIsMoreRecommendations(!isMoreRecommendations);
    handleClose(val);
    if (!val) {
      handleBookValidation(state.id, false);
    }
  };

  const styleImgRes = isMobile
    ? {}
    : isDefaultHeight
    ? {}
    : {
        height: "440px",
      };

  const styleVideoRes = isMobile
    ? {}
    : isDefaultHeight
    ? {}
    : {
        height: "460px",
      };

  return (
    <div className="CareerCont">
      <div className="infoCont">
        <div className="CareerCont__header">
          <div
            onClick={() => {
              navigateBack();
            }}
            className={classNames("CareerCont__header__iconWrapper", {
              hide: isMobile,
            })}
          >
            <img
              src={arrowLeft}
              alt=""
              className="CareerCont__header__iconWrapper__icon"
            />
          </div>
          <div className="CareerCont__header__textCont">
            <p
              className={classNames("CareerCont__header__textCont__Profecy", {
                // hide: isMobile,
              })}
            >
              {state?.unique_title?.mask_title
                ? state?.unique_title?.mask_title
                : state?.text}
            </p>
            <p className="CareerCont__header__textCont__mentor">
              <span className="CareerCont__header__textCont__mentor__key">
                Mentor:{" "}
              </span>
              {state?.first_name}
            </p>
          </div>
        </div>
        <div className="CareerCont__decription__content">
          {isHTML(state?.description_long) && state?.description_long ? (
            <div
              className="CareerCont__decription"
              dangerouslySetInnerHTML={{ __html: state?.description_long }}
            />
          ) : (
            <p className="CareerCont__decription" ref={descriptionRef}>
              {state?.description_long
                ? formatText(state.description_long)
                : ""}
            </p>
          )}
          {state?.unique_title?.resource &&
            (state?.unique_title?.resource_type === "image" ? (
              <img
                src={state?.unique_title.resource}
                width="200px"
                loading="eager"
            decoding="async"
            rel="preload"
                className="CareerCont__decription__contentImg"
                alt="Resource"
                style={styleImgRes}
              />
            ) : (
              <VideoPlayer
                styleRes={styleVideoRes}
                videoSrc={state?.unique_title.resource}
              />
            ))}
        </div>
       
<Chatbot
          question={state?.unique_title?.unique_title_questions}
          isMoreRecommendations={isMoreRecommendations}
          agentId={state?.agent_id}
          profile={profile}
          maskTitle={state?.unique_title?.mask_title}
          impact={state?.unique_title?.impact}
        />
      </div>
      <ChoosePlanFirstModal
        isOpened={choosePlanFirstOpen}
        onClose={closeChoosePlanFirstModal}
        onContinue={confirmChoosePlanFirstModal}
      />
      <AffiliateCodeModal
        {...affiliateCodeModal}
        onBack={closeAffiliateCodeModal}
        onChange={setAffiliateCode}
        onSuccessClose={closeAffiliateCodeModal}
        onPricingPlanClick={() => {
          closeAffiliateCodeModal();
          navigate("/pricingplan");
        }}
        onSubmit={submitAffiliateCode}
      />
      {state && (
        <BookModal
          handlescore={handlescore}
          chosenItem={state}
          handleBook={handleRecommend}
          text={state?.description}
          isContentType={true}
          handleBack={() => handleBack(state.id)}
          handleSaveCareer={(val)=>!isErrorPricing.plan_active ? openAffiliateCodeModal():handleSaveCareer(val)}
          isSavedCareer={isSavedCareer}
          interestedCareerSaved={interestedCareerSaved}
          showLoader={showLoader}
        />
      )}
      <MoreRecommendations
        title="Choose your way to learn more."
        isOpened={isMoreRecommendations}
        isErrorPricing={!isErrorPricing.plan_active}
        handleRecommend={handleRecommend}
        onClose={() => handleRecommend(null)}
        aiReportUrl={profile?.ai_report}
        careerOutlookVal={state?.unique_title}
        allowCareerBuddy={allowCareerBuddy}
      />
      <CancelModal
        image={modalInfo[isConfirmModal]?.image}
        title={modalInfo[isConfirmModal]?.title}
        text={modalInfo[isConfirmModal]?.text}
        text2={modalInfo[isConfirmModal]?.text2}
        isOpened={isConfirmModal}
        removeChanges={handleConfirm}
        leftBtnText="Back"
        rightBtnText="Okay"
        close={() => handleClose(null)}
      />
    </div>
  );
};

export default Career;
